import React from 'react';
import styles from './style.module.scss';
import Footer from 'components/footer';
import { Form, Input, Button, Checkbox, Row, Col, Typography } from 'antd';
import { LogoDarkIcon } from 'icons';
import LoginForm from './form';
import useAuth from './useAuth';
import ResetForm from './resetForm';

const ForgotPassword = () => {
  const { handleLogin, loadingBtn, errors, searchParams, handleResetPassword } =
    useAuth();

  const onSubmit = (values) => {
    handleLogin(values);
  };

  const isSuccesPage = searchParams.get('success') === 'true';
  const isResetPassword = !!searchParams.get('reset_password_token');
  return (
    <div className={styles.loginPageContainer}>
      <div className={styles.loginPageContainer_content}>
        <div>
          <LogoDarkIcon />
        </div>
        {isSuccesPage && !isResetPassword && (
          <Row>
            <Col>
              <Typography.Title level={3}>
                Reset della password
              </Typography.Title>
              <Typography.Text>
                {' '}
                Abbiamo inviato una mail all’indirizzo che hai fornito.
                Controlla la tua posta elettronica.
              </Typography.Text>
            </Col>
          </Row>
        )}
        {!isSuccesPage && !isResetPassword && (
          <LoginForm
            errors={errors}
            loadingBtn={loadingBtn}
            onSubmit={onSubmit}
          />
        )}
        {isResetPassword && (
          <>
            <Typography.Title level={3}>Reset della password</Typography.Title>
            <ResetForm
              errors={errors}
              loadingBtn={loadingBtn}
              onSubmit={handleResetPassword}
            />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
